export default "__VITE_ASSET__x800$x3r__"